import { findStateIcon } from "@/assets/states/StateIcon";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import type { StatefulDiaryT } from "@/types/database/diaries";
import { StateCard } from "./StateCard";

interface StateCardsProps {
	diaries: StatefulDiaryT[];
}

export function StateCards({ diaries }: StateCardsProps) {
	// Prepare data for the diary outcome chart (diary_status-based)
	const diaryOutcomeData = [
		{
			name: "Calculating",
			value: diaries.filter(
				(d) =>
					d.diary_status !== "NEVER_WORKED" &&
					d.diary_status !== "PAIN_SPIKE" &&
					d.diary_status !== "PAIN_REDUCED",
			).length,
			icon: findStateIcon("ACTIVE"),
		},
		{
			name: "Never Worked",
			value: diaries.filter((d) => d.diary_status === "NEVER_WORKED").length,
			icon: findStateIcon("NEVER_WORKED"),
		},
		{
			name: "Pain Spike",
			value: diaries.filter((d) => d.diary_status === "PAIN_SPIKE").length,
			icon: findStateIcon("PAIN_SPIKE"),
		},
		{
			name: "Pain Reduced",
			value: diaries.filter((d) => d.diary_status === "PAIN_REDUCED").length,
			icon: findStateIcon("PAIN_REDUCED"),
		},
	];

	return (
		<div className="gap-3 grid grid-cols-2 w-full md:w-1/3">
			<StateCard
				label="Never Worked"
				value={
					diaryOutcomeData.find((d) => d.name === "Never Worked")?.value || 0
				}
				stateKey="NEVER_WORKED"
				variant="red"
			/>
			<StateCard
				label="Calculating"
				value={
					diaryOutcomeData.find((d) => d.name === "Calculating")?.value || 0
				}
				stateKey="EMPTY_DIARY"
				variant="slate"
			/>
			<StateCard
				label="Pain Spike"
				value={
					diaryOutcomeData.find((d) => d.name === "Pain Spike")?.value || 0
				}
				stateKey="PAIN_SPIKE"
				variant="amber"
			/>
			<StateCard
				label="Pain Reduced"
				value={
					diaryOutcomeData.find((d) => d.name === "Pain Reduced")?.value || 0
				}
				stateKey="PAIN_REDUCED"
				variant="green"
			/>
		</div>
	);
}
